// extracted by mini-css-extract-plugin
export default {"root":"LoadingIndicator_root__p2RO7","message":"LoadingIndicator_message__EfeGP"};